import React from 'react';
import SessionStore from 'stores/SessionStore';
import EditButton from 'components/v2/buttons/EditButton';
import UserButton from 'components/v2/buttons/UserButton';
import Tooltip from 'components/v2/Tooltip';
import { useTranslation } from 'react-i18next';

const canAdjust = (shipmentIsCurrent) => {
  const isFinanceUser = SessionStore.hasFinanceRole();
  return isFinanceUser || shipmentIsCurrent;
};

export default function AdjustmentActions({
  lineItem,
  shipmentIsCurrent,
  isIntermodalShipmentType,
  onAddCustomAdjustment,
  onAddShipperCostAdjustment,
  onAddInternalAdjustment,
  onAddCustomerAdjustment,
}) {
  const { t } = useTranslation();
  if (!canAdjust(shipmentIsCurrent)) {
    return null;
  }

  const { category, isFirstFuelSurchargeItem } = lineItem;
  if (category === 'rate_adjustments' || category === 'incentive_payments') {
    return null;
  }

  if (isIntermodalShipmentType) {
    if (lineItem.processed && lineItem.parent_adjustment_id) return null;
    return (
      <>
        {lineItem.category === 'base_cost' &&
          lineItem.adjusted_item === 'base_cost' &&
          !lineItem.isCreditMemo &&
          lineItem.message !== 'Shipper Cost Adjustment' && (
            <Tooltip
              dataTestId="Tooltip-55b3a8a4"
              id={`custom-adj-tooltip-${lineItem._id}`}
              className="w-10 h-10"
              position="top"
              body={() => (
                <div data-testid="div-8f725c37">
                  {lineItem.hasInvoice ? (
                    <EditButton
                      dataTestId="EditButton-c57686f1"
                      onClick={() => onAddShipperCostAdjustment(lineItem)}
                    />
                  ) : (
                    <EditButton
                      dataTestId="EditButton-bb40e2a8"
                      onClick={() => onAddCustomAdjustment(lineItem)}
                    />
                  )}
                </div>
              )}
            >
              {lineItem.hasInvoice
                ? t('SHIPPER_COST_ADJUSTMENT')
                : t('ADD_ADJUSTMENT')}
            </Tooltip>
          )}
        {lineItem.category === 'accessorials' &&
          lineItem.type === 'fuel_surcharge' &&
          !lineItem.has_pending_state &&
          (isFirstFuelSurchargeItem || lineItem.parent_adjustment_id) &&
          !lineItem.accessorial_request_id && (
            <Tooltip
              dataTestId="Tooltip-c02a9871"
              id={`custom-adj-tooltip-${lineItem._id}`}
              className="w-10 h-10"
              position="top"
              body={() => (
                <div data-testid="div-bd1155e8">
                  <EditButton
                    dataTestId="EditButton-e60bf284"
                    onClick={() => onAddCustomAdjustment(lineItem)}
                  />
                </div>
              )}
            >
              {t('ADD_ADJUSTMENT')}
            </Tooltip>
          )}
      </>
    );
  }

  const internalAdjTooltipId = `internal-adj-tooltip-${lineItem._id}`;
  const customerAdjTooltipId = `customer-adj-tooltip-${lineItem._id}`;
  return (
    <div
      data-testid="div-4a444f63"
      className="flex flex-wrap items-center space-x-1"
    >
      <Tooltip
        dataTestId="Tooltip-fafb3ff4"
        id={internalAdjTooltipId}
        className="w-10 h-10"
        body={() => (
          <div data-testid="div-0de61c80" className="w-10 h-10">
            <EditButton
              dataTestId="EditButton-b49b6d9f"
              onClick={() => onAddInternalAdjustment(lineItem)}
            />
          </div>
        )}
      >
        {t('ADD_INTERNAL_ADJUSTMENT')}
      </Tooltip>
      <Tooltip
        dataTestId="Tooltip-83bd131d"
        id={customerAdjTooltipId}
        className="w-10 h-10"
        body={() => (
          <UserButton
            dataTestId="UserButton-3c49fd21"
            onClick={() => onAddCustomerAdjustment(lineItem)}
          />
        )}
      >
        {t('ADD_CUSTOMER_ADJUSTMENT')}
      </Tooltip>
    </div>
  );
}
